<template>
    <div class = "container-fluid">
        <div class="row">
            <div id='base' class="container-fluid">
                <div v-if="loading" class="text-center">
                    <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                </div>
                <canvas
                        ref="the-canvas"
                        @mousedown="canvasMouseDown"
                        @mousemove="canvasMouseMove"
                        @mouseup="canvasMouseUp"
                        @contextmenu="canvasContextMenu"
                        ></canvas>
                <!-- <canvas
                        ref="pdf-canvas"
                        ></canvas>
                -->
                <div class="container-fluid">
                    <div class="row">
                        <button class="btn btn-light col-1" @click="zoomIn">
                            <i class="bi bi-zoom-in"></i>
                        </button>
                        <button class="btn btn-light col-1" @click="cancelZoom">
                            x1.0
                        </button>
                        <button class="btn btn-light col-1" @click="zoomOut">
                            <i class="bi bi-zoom-out"></i>
                        </button>

                        <button class="btn btn-light col-1" @click="prevPage" :disabled="openInfo.page == 1">
                            <i class="bi bi-arrow-left-circle"></i>
                        </button>
                        <input type="range" class="form-range col" @change="setPage" min="1" :max="pdfdoc ? pdfdoc.numPages : 1" step="1"/>
                        <button class="btn btn-light col-1" @click="nextPage" :disabled="pdfdoc && openInfo.page >= pdfdoc.numPages ">
                            <i class="bi bi-arrow-right-circle"></i>
                        </button>
                    </div>
                </div>
                <div class="toast" role="alert" ref="msgToast">
                    <div class="toast-body">{{message}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import { defineComponent } from '@vue/composition-api'
import workerSrc from '!!file-loader!pdfjs-dist/build/pdf.worker.min.js'
import _ from 'lodash';
import {Toast} from 'bootstrap'

const pdfjsLib = require(/* webpackChunkName: "pdfjs-dist" */ `pdfjs-dist`)
pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc

import utils from '../utils/utils.js';

export default {
    name: "PdfPane",
    components: {
    },
    props: {
        bucketname: { type: String, required: true},
        openInfo: { type: Object, required: true},
        displayOnly: { type: Boolean, required: false},
        anchors:{ type: Array, required: true},
        maxPage:{ type: Number, required: false},
    },
    data: function() {
        return {
            pdfdoc: null,
            objname: '',
            page: 0,
            scale: 1.0,
            offset: {x: 0, y:0},
            startPos: null,
            startOffset: null,
            rectangles: [],
            loading: false,
            canvasSize: null,
            pdfCanvas: null,
            message: "",
            toast: null,
        }
    },
    async mounted() {
        this.scale = 1.0;
        // this.pdfCanvas = this.$refs['pdf-canvas'];
        this.pdfCanvas = document.createElement('canvas');
        this.pdfCanvas.getContext('2d', {willReadFrequently:true}); //set willReadFrequently = true
        if(!this.objname){
            console.log(this);
        }
        if(this.$store.state.gToken && this.$store.state.userid){
            await this.openPdf(this.openInfo.obj, this.openInfo.page);
        } else {
            console.log("NO TOKEN OR USERID") 
        }

        this.toast = new Toast(this.$refs.msgToast);
        //this.pdfCanvas = document.createElement('canvas');
        console.log("MOUNTED--------")
    },
    methods: {
        async getUrl(bucketname, objname){
            let param = new URLSearchParams({obj: objname});
            //let res = await fetch(`https://limar-dev.zanreko.com/api/downloadurl/${bucketname}?` + param);
            let res = await utils.get(`/api/downloadurl/${bucketname}?` + param);
            return res['url'];
        },
        async openPdf(objname, page) {
            if(!objname){
                console.log("openPdf is avoided due to no objname");
                return;
            }
            console.log(`Opening PDF ${objname}`)
            if(!objname){
                console.log("NO OBJECT NAME")
                return;
            }
            this.objname = objname;
            console.log("-- OPEN PDF --" + this.objname, page);
            try {
                this.loading = true;
                let url = await this.getUrl(this.bucketname, objname);
                let res = await fetch(url, {
                    responseType : 'arraybuffer',
                    m_ode: 'cors',
                    headers: {
                        'Accept':'application/pdf',
                    }
                });
                if(this.pdfdoc){ this.pdfdoc.destroy(); }
                this.pdfdoc = await pdfjsLib.getDocument(await res.arrayBuffer()).promise;
                this.$emit('pdf-opened', this.pdfdoc.numPages);
                if(page){
                    let _this = this;
                    this.$nextTick( async function(){
                        this.page = page;
                        await _this.renderPage();
                    });
                }
            } finally {
                this.loading = false;
            }
        },
        drawRectangle(ctx, x, y, w, h, color) {
            ctx.strokeStyle = color;
            ctx.strokeRect(x, y, w, h);

        },

        coordScreenToPdf(x, y){
            let canvas = this.$refs['the-canvas'];
            return {
                x: (x + this.offset.x) * 100 / (this.scale * canvas.width),
                y: (y + this.offset.y) * 100 / (this.scale * canvas.width),
            }
        },
        coordPdfToScreen(x, y){
            let canvas = this.$refs['the-canvas'];
            return {
                x: canvas.width * x / 100 * this.scale + this.offset.x,
                y: canvas.height * y / 100 * this.scale + this.offset.y,
            }
        },
        async updatePage(){
            let canvas = this.$refs['the-canvas'];
            let ctxMain = canvas.getContext('2d');
            let ctxPdf = this.pdfCanvas.getContext('2d');
            ctxMain.putImageData(
                ctxPdf.getImageData(
                    -this.offset.x, -this.offset.y, 
                    canvas.width, canvas.height
                ), 0, 0 
            );
            if(!this.displayOnly) {
                console.log("UPDATING PAGE");
                this.rectangles = this.anchors.map((a) => {
                    let color = 'gray';
                    if(a.dst_hyperlinks.length > 0){
                        color = 'red';
                    } else if(a.src_hyperlinks.length > 0) {
                        color = 'blue';
                    }
                    return a.bounds.map( (p) => {
                        let lt = this.coordPdfToScreen(p[0], p[1]); // lefttop
                        let rb = this.coordPdfToScreen(p[2], p[3]); // rightbottom
                        return { 
                            w: rb.x - lt.x, h: rb.y - lt.y,
                            x: lt.x, y: lt.y,
                            id: a.id, color: color,
                            is_reference: a.is_reference}
                    })
                }).flat();
                for(let r of this.rectangles) {
                    this.drawRectangle(ctxMain, r.x, r.y, r.w, r.h, r.color);
                }
            }
        },
        async renderPage() {
            console.log(`PDF PANE: RENDERING ${this.page}`)
            if(this.page == 0){
                console.log("Avoid Rendering. Page 0 is set");
                this.loading = false;
                return
            }
            if(this.pdfdoc.numPages < this.page){
                alert(`TOO BIG PAGE NUMBER: ${this.page}`);
                this.loading = false;
                return
            }
            console.log(`START RENDERING----${this.page}`);
            if(!this.pdfdoc._transport.messageHandler){
                console.log(`NO MESSAGE HANDLER`);
                this.loading = false;
                return;
            }

            this.loading = true;
            let _page = await this.pdfdoc.getPage(parseInt(this.page))
            var viewport = _page.getViewport({scale:this.scale * window.devicePixelRatio});
            let ctx = this.pdfCanvas.getContext('2d');
            this.pdfCanvas.height = viewport.height;
            this.pdfCanvas.width = viewport.width;
            this.canvasSize = { w: this.pdfCanvas.width, h: this.pdfCanvas.height };

            // set main window size
            let v= _page.getViewport({scale: window.devicePixelRatio});
            let c = this.$refs['the-canvas'];
            c.width = v.width;
            c.height = v.height;
            c.style = `aspect-ratio: ${c.width / c.height}`;

            this.pdfCanvas.style = `aspect-ratio: ${this.pdfCanvas.width / this.pdfCanvas.height}`;

            var renderContext = {
                canvasContext: ctx,
                viewport: viewport
            };
            await _page.render(renderContext).promise;
            await this.updatePage();

            /*
            let _page = await this.pdfdoc.getPage(parseInt(pageNum))
            var viewport = _page.getViewport({scale:this.scale * window.devicePixelRatio});
            var canvas = this.$refs['pdf-canvas'];
            let ctx = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            this.canvasSize = { w: canvas.width, h: canvas.height };

            ctx.scale(this.scale, this.scale);
            ctx.translate(Math.min(this.offset.x, 0), Math.min(this.offset.y, 0));
            canvas.style = `aspect-ratio: ${canvas.width / canvas.height}`
            var renderContext = {
                canvasContext: ctx,
                viewport: viewport
            };
            await _page.render(renderContext).promise
            */
            
            this.loading = false;
        },
        renderPageDebounce: _.debounce( async function() {
            await this.renderPage();
        }, 500),
        renderPageThrottle: _.throttle( async function() {
            await this.renderPage();
        }, 500),
        updatePageThrottle: _.throttle( async function() {
            await this.updatePage();
        }, 100),
        prevPage: _.debounce( async function(){
            console.log("DO PREV PAGE");
            this.$emit('page-changed', Number(this.page) - 1);
        }, 500),
        nextPage: _.debounce( async function(){
            console.log("DO NEXT PAGE");
            this.$emit('page-changed', Number(this.page) + 1);
        }, 500),
        setPage(event){
            this.$emit('page-changed', event.target.value);
        },
        zoomIn(){
            console.log("ZOOMIN");
            this.scale = Math.min(4.0, this.scale + 0.1);
        },
        zoomOut(){
            this.scale = Math.max(1.0, this.scale - 0.1);
        },
        cancelZoom(){
            this.scale = 1.0;
        },
        hitTest(x, y){
            for(let rect of this.rectangles) {
                // console.log('x=', rect.x, _x);
                // console.log('y=', rect.y, _y);
                if(rect.x < x && x< rect.x + rect.w && rect.y < y && y < rect.y + rect.h) {
                    return rect;
                }
            }
            return null;
        },
        async canvasMouseDown(e){
            let k = this.canvasSize.w / (this.scale * e.target.clientWidth);
            let _x = k * e.offsetX;
            let _y = k * e.offsetY;
            // let ctx = this.$refs['the-canvas'].getContext('2d');
            // this.drawRectangle(ctx, _x, _y, 10, 10);

            if(!this.displayOnly) {
                let hit = this.hitTest(_x, _y);
                if(hit) {
                    this.$emit('target-selected', hit.id);
                } 
            } else {
                this.$emit('target-selected', null);
            }

            if(this.scale > 1.0) {
                this.startPos = e;
                this.startOffset = {x: this.offset.x, y: this.offset.y};
            }
        },
        canvasMouseMove(e){
            e.preventDefault();
            e.stopPropagation();
            if(!this.pdfdoc || !this.canvasSize) { return; }

            let k = this.canvasSize.w / (this.scale * e.target.clientWidth);
            if(!this.startPos){ 
                let _x = k * e.offsetX - this.offset.x;
                let _y = k * e.offsetY - this.offset.y;
                let hit = this.hitTest(_x, _y);
                let showPointer = false;
                if(hit){
                    let anchor = this.anchors.find(a => a.id == hit.id);
                    if(anchor){
                        showPointer = anchor.src_hyperlinks.length > 0 || anchor.dst_hyperlinks.length > 0;
                        this.message = `${anchor.id} ${anchor.rawtxt}`;
                        this.toast.show();
                    }
                }
                e.target.style.cursor = showPointer ? 'pointer':'auto';

            } else {
                this.offset.x = Math.min(this.startOffset.x + (e.offsetX - this.startPos.offsetX) * k, 0)
                this.offset.y = Math.min(this.startOffset.y + (e.offsetY - this.startPos.offsetY) * k, 0);
                this.updatePageThrottle();
            }
        },
        canvasMouseUp(e){
            if(!this.startPos){ return; }
            let k = this.canvasSize.w / (this.scale * e.target.clientWidth);
            this.offset.x = Math.min(this.startOffset.x + (e.offsetX - this.startPos.offsetX) * k, 0)
            this.offset.y = Math.min(this.startOffset.y + (e.offsetY - this.startPos.offsetY) * k, 0);
            this.startPos = null;
            this.startOffset = null;
            this.updatePageThrottle();
        },
        canvasContextMenu(e) {
            console.log("CONTEXT MENU");
            e.preventDefault();
        },
    },
    watch: {
        /* anchors: async function() {
            console.log("PDF PANE - ANCHORS CHANGED");
            if(!this.pdfdoc){ await this.openPdf(this.openInfo.obj); }
            this.$nextTick(async function(){
                this.page = this.page || this.openInfo.page;
                await this.renderPageDebounce();
                //await this.renderPage(this.page || this.openInfo.page);
            });
        },*/
        openInfo: async function(newObj) {
            console.log("OpenInfo CHANGED");
            console.log(newObj);
            this.scale = 1.0;
            let pdfChanged = false;
            if(!this.$store.state.gToken || !this.$store.state.userid){ return; }
            if(!this.pdfdoc || this.objname !== newObj.obj) {
                await this.openPdf(newObj.obj);
                pdfChanged = true; 
            }
            if(pdfChanged || this.page != newObj.page){
                this.page = newObj.page;
                await this.renderPageDebounce();
            }
        },
        page: async function(newPage){
            console.log("PAGE CHANGED:" + newPage);
            if(!this.pdfdoc){ await this.openPdf(this.openInfo.obj); }
            else {
                this.page = newPage;
                await this.renderPageDebounce();
            }
        },
        "$store.state.userid": async function(newval) {
            console.log("USERID CHANGED");
            this.objname = this.openInfo.objname || this.openInfo.obj;
            console.log('objname is' + this.objname);
            if(newval && this.bucketname && this.objname) {
                if(!this.displayOnly){
                    this.$emit('update-anchors', this.openInfo.page);
                } else {
                    await this.openPdf(this.openInfo.obj, this.page || this.openInfo.page);
                }
            }
        },
        scale: async function(newVal) {
            console.log("SCALED CHANGED:" + newVal);
            this.offset = {x: 0, y: 0};
            this.renderPageDebounce();
        },
    }
}
</script>

<style scoped>
canvas {
    width: 100%;
    background-color: lightgray;
}
#base {
    position: relative;
}
.toast {
    position: absolute;
    bottom: 40px;
    left: 0;
    right: 0;
    margin: auto
}
</style>
